/* RYTM Subscription PDP Buy Box behaviour.
   Vanilla JS, no dependencies, safe for multiple instances per page.
   Independent of rytm-buy-box.js — both can run on the same page. */
(function () {
  'use strict';

  function initGallery(root) {
    var group = root.querySelector('.rytm-subbox__image-group');
    if (!group) return;

    var images = Array.prototype.slice.call(group.querySelectorAll('.rytm-subbox__image'));
    var dots = Array.prototype.slice.call(group.querySelectorAll('.rytm-subbox__image-dot'));
    if (images.length < 2) return;

    function currentIndex() {
      for (var i = 0; i < images.length; i++) {
        if (images[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    function setActive(index) {
      images.forEach(function (img, i) {
        img.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { setActive(i); });
    });

    var prevBtn = group.querySelector('.rytm-subbox__image-arrow--prev');
    var nextBtn = group.querySelector('.rytm-subbox__image-arrow--next');

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var i = currentIndex();
        setActive(i === 0 ? images.length - 1 : i - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var i = currentIndex();
        setActive(i === images.length - 1 ? 0 : i + 1);
      });
    }
  }

  function initAccordion(root) {
    var triggers = Array.prototype.slice.call(root.querySelectorAll('.rytm-subbox__collapsible-trigger'));

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      });
    });
  }

  /* ---------- Cart ----------

     Self-contained AJAX add-to-cart, identical in behaviour to the bundle buy
     box. Deliberately NOT wired to the theme's <product-form-component>: that
     routes the add through Horizon's own validation and changes how
     out-of-stock is handled. This posts the exact same body the plain form was
     already posting, and then IGNORES the response — success or failure — so
     add-to-cart behaves exactly as it did with the plain form POST. The only
     difference is that we stay on the page and open the cart drawer instead of
     letting the browser navigate to /cart.

     Do not add error handling here: surfacing the response is precisely the
     behaviour change we're avoiding. */

  function cartSectionIds() {
    // Discovered from the DOM, never hardcoded. cart-items-component publishes
    // its own section id; the header badge lives in a different section, found
    // via the <cart-icon> element's shopify-section wrapper.
    var ids = [];

    function push(id) {
      if (id && ids.indexOf(id) === -1) ids.push(id);
    }

    var items = document.querySelector('cart-items-component');
    if (items) push(items.dataset.sectionId);

    var icon = document.querySelector('cart-icon');
    var wrapper = icon && icon.closest ? icon.closest('[id^="shopify-section-"]') : null;
    if (wrapper) push(wrapper.id.replace('shopify-section-', ''));

    return ids;
  }

  function applySections(sections) {
    // Shopify returns each requested section as a full HTML string. Swapping
    // the inner HTML re-creates the custom elements inside, which re-upgrade
    // themselves on insertion.
    if (!sections) return false;

    var applied = false;

    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (typeof html !== 'string') return;

      var current = document.getElementById('shopify-section-' + id);
      if (!current) return;

      var fresh = new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementById('shopify-section-' + id);
      if (!fresh) return;

      current.innerHTML = fresh.innerHTML;
      applied = true;
    });

    return applied;
  }

  function refreshCartData() {
    var items = document.querySelector('cart-items-component');
    if (items && typeof items.fetchCartData === 'function') {
      try { items.fetchCartData(); } catch (err) { /* ignore */ }
    }
  }

  function openCartDrawer() {
    // Horizon's drawer is <theme-drawer id="cart-drawer"> and exposes open().
    // Re-queried on every call because applySections() may have replaced it.
    var drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }

    // Fallback: click the cart icon, the same way a shopper would.
    var icon = document.querySelector('cart-icon, .header-actions__cart-icon');
    if (icon) {
      (icon.closest('a, button, [role="button"]') || icon).click();
      return true;
    }

    return false;
  }

  function initCart(root) {
    var form = root.querySelector('.rytm-subbox__form');
    if (!form) return;

    // Opt-in console tracing (section setting "Developer > Log add-to-cart
    // details"). It only ever READS — no branching on status, so the
    // out-of-stock behaviour below is untouched.
    var debug = root.dataset.debug === 'true';
    var submitting = false;

    form.addEventListener('submit', function (event) {
      // Without JS this listener never runs and the form posts normally, so
      // the section still works with scripts disabled.
      event.preventDefault();
      if (submitting) return;
      submitting = true;

      var button = form.querySelector('.rytm-subbox__cta');
      if (button) button.disabled = true;

      // FormData(form) reproduces the original POST body — including
      // `selling_plan` when the subscription option is selected, and omitting
      // it when the hidden input is disabled for a one-time purchase.
      // `sections` asks Shopify to return refreshed markup for the cart
      // drawer and header.
      var body = new FormData(form);
      var sectionIds = cartSectionIds();
      if (sectionIds.length) {
        body.append('sections', sectionIds.join(','));
        body.append('sections_url', window.location.pathname);
      }

      if (debug) {
        var posted = {};
        body.forEach(function (value, key) { posted[key] = value; });
        console.log('[RYTM subbox] POST /cart/add.js', posted);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: body,
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (debug) {
            console.log('[RYTM subbox] response', data);
            fetch('/cart.js', { credentials: 'same-origin' })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                console.log('[RYTM subbox] cart lines', (cart.items || []).map(function (item) {
                  return {
                    title: item.title,
                    final_price: item.final_price,
                    original_price: item.original_price,
                    selling_plan: item.selling_plan_allocation
                      ? item.selling_plan_allocation.selling_plan.name
                      : null
                  };
                }));
              })
              .catch(function () { /* ignore */ });
          }
          return data;
        })
        // Only `sections` is ever read. Status and message are deliberately
        // ignored: a refused add leaves the cart markup untouched and the
        // drawer simply opens on the existing cart, which is what the plain
        // form POST effectively did.
        .then(function (data) { return applySections(data && data.sections); })
        .catch(function () { return false; })
        .then(function (applied) {
          if (!applied) refreshCartData();
          // Let the re-inserted custom elements upgrade before opening.
          setTimeout(openCartDrawer, 0);
          submitting = false;
          if (button) button.disabled = false;
        });
    });
  }

  /* ---------- Subscription vs. one-time ----------

     The only thing that distinguishes the two adds is whether the hidden
     `selling_plan` input is submitted. Disabling the input keeps it out of the
     FormData entirely, which is what Shopify expects for a one-time purchase —
     an empty value would also work, but a disabled field is unambiguous. */

  function initOptions(root) {
    var radios = Array.prototype.slice.call(root.querySelectorAll('.rytm-subbox__radio'));
    if (!radios.length) return;

    var planInput = root.querySelector('[data-rytm-selling-plan-input]');
    var freqSelect = root.querySelector('[data-rytm-frequency]');
    var priceEl = root.querySelector('[data-rytm-sub-price]');
    var perDayEl = root.querySelector('[data-rytm-sub-per-day]');
    var compareEl = root.querySelector('[data-rytm-sub-compare]');
    var bannerEl = root.querySelector('[data-rytm-banner]');
    var savingsLabel = root.dataset.savingsLabel || '';

    function syncPlanFromSelect() {
      if (!freqSelect) return;

      var option = freqSelect.options[freqSelect.selectedIndex];
      if (!option) return;

      if (planInput) planInput.value = option.value;
      if (priceEl && option.dataset.price) priceEl.textContent = option.dataset.price;
      if (perDayEl && option.dataset.perDay) perDayEl.textContent = option.dataset.perDay;

      var percent = parseInt(option.dataset.percent, 10);
      if (isNaN(percent)) percent = 0;

      if (compareEl) compareEl.hidden = percent <= 0;

      if (bannerEl) {
        var prefix = bannerEl.dataset.prefix || '';
        bannerEl.textContent = percent > 0
          ? prefix + ' — ' + percent + ' % ' + savingsLabel
          : prefix;
      }
    }

    function applySelection(radio) {
      var option = radio.dataset.option || 'onetime';
      root.setAttribute('data-selected', option);
      if (planInput) planInput.disabled = option !== 'subscription';
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) applySelection(radio);
      });
    });

    if (freqSelect) {
      // The select sits inside the subscription row's <label>; without this the
      // label would forward the click to the radio and some browsers never open
      // the dropdown.
      freqSelect.addEventListener('click', function (event) { event.stopPropagation(); });

      // Touching the frequency picker means you want the subscription.
      freqSelect.addEventListener('focus', function () {
        var subRadio = root.querySelector('.rytm-subbox__radio[data-option="subscription"]');
        if (subRadio && !subRadio.checked) {
          subRadio.checked = true;
          applySelection(subRadio);
        }
      });

      freqSelect.addEventListener('change', function () {
        var subRadio = root.querySelector('.rytm-subbox__radio[data-option="subscription"]');
        if (subRadio && !subRadio.checked) {
          subRadio.checked = true;
          applySelection(subRadio);
        }
        syncPlanFromSelect();
      });

      syncPlanFromSelect();
    }

    var checked = radios.filter(function (radio) { return radio.checked; })[0] || radios[0];
    if (checked) {
      checked.checked = true;
      applySelection(checked);
    }
  }

  /* ---------- Layout diagnostics ----------

     Only runs with the "Developer > Log add-to-cart details" setting on, or
     when called by hand as window.rytmSubboxDiagnose(). Prints the real
     geometry of both option rows and of every ancestor above them, so a width
     mismatch can be traced to the exact element and property causing it
     instead of being guessed at from a screenshot. */

  function describe(el) {
    var name = el.tagName.toLowerCase();
    var cls = typeof el.className === 'string' ? el.className.trim() : '';
    return cls ? name + '.' + cls.split(/\s+/).join('.') : name;
  }

  function diagnose(root) {
    var rows = Array.prototype.slice.call(root.querySelectorAll('.rytm-subbox__row'));

    console.log('[RYTM subbox] rows — compare left/right/width between the two');
    console.table(rows.map(function (row) {
      var cs = getComputedStyle(row);
      var rect = row.getBoundingClientRect();
      var radio = row.querySelector('.rytm-subbox__radio');
      var name = row.querySelector('.rytm-subbox__row-name');
      var body = row.querySelector('.rytm-subbox__row-body');
      var radioRect = radio ? radio.getBoundingClientRect() : { left: 0, width: 0 };
      return {
        row: row.className.indexOf('--sub') > -1 ? 'ABO' : 'EINMAL',
        left: +rect.left.toFixed(1),
        right: +rect.right.toFixed(1),
        width: +rect.width.toFixed(1),
        scrollWidth: row.scrollWidth,
        border: cs.borderLeftWidth + ' / ' + cs.borderRightWidth,
        margin: cs.marginLeft + ' / ' + cs.marginRight,
        cssWidth: cs.width,
        alignSelf: cs.alignSelf,
        transform: cs.transform,
        bodyPadL: body ? getComputedStyle(body).paddingLeft : '-',
        radioBox: radio ? getComputedStyle(radio).boxSizing : '-',
        radioLeft: +radioRect.left.toFixed(1),
        radioW: +radioRect.width.toFixed(1),
        nameLeft: name ? +name.getBoundingClientRect().left.toFixed(1) : null
      };
    }));

    console.log('[RYTM subbox] ancestors — find where the width stops matching');
    var chain = [];
    var el = root.querySelector('.rytm-subbox__options') || root;
    while (el && el !== document.documentElement) {
      var acs = getComputedStyle(el);
      chain.push({
        element: describe(el),
        width: +el.getBoundingClientRect().width.toFixed(1),
        display: acs.display,
        flexDirection: acs.flexDirection,
        alignItems: acs.alignItems,
        cssWidth: acs.width,
        minWidth: acs.minWidth,
        maxWidth: acs.maxWidth,
        padding: acs.paddingLeft + ' / ' + acs.paddingRight
      });
      el = el.parentElement;
    }
    console.table(chain);
  }

  /* ---------- On-page debug overlay ----------

     Add ?subboxdebug=1 to the product URL. Draws a magenta hairline at each
     option row's exact left and right border-box edge and prints the measured
     numbers in a corner panel, so a single screenshot from ANY browser shows
     whether the two cards really are the same box — no console needed. Does
     nothing without the URL parameter. */

  function debugOverlay(root) {
    var rows = Array.prototype.slice.call(root.querySelectorAll('.rytm-subbox__row'));
    if (!rows.length) return;

    var lines = [
      'viewport ' + window.innerWidth + ' x ' + window.innerHeight + '   dpr ' + window.devicePixelRatio,
      'zoom ' + Math.round((window.outerWidth / window.innerWidth) * 100) + '%',
      navigator.userAgent.slice(0, 90)
    ];

    rows.forEach(function (row) {
      var rect = row.getBoundingClientRect();
      var label = row.className.indexOf('--sub') > -1 ? 'ABO   ' : 'EINMAL';
      var cs = getComputedStyle(row);

      lines.push(
        label +
        '  L ' + rect.left.toFixed(2) +
        '  R ' + rect.right.toFixed(2) +
        '  W ' + rect.width.toFixed(2) +
        '  border ' + cs.borderLeftWidth +
        '  clip ' + cs.backgroundClip
      );

      [rect.left, rect.right].forEach(function (x) {
        var mark = document.createElement('div');
        mark.style.cssText = [
          'position:absolute',
          'z-index:2147483646',
          'pointer-events:none',
          'background:magenta',
          'width:1px',
          'left:' + (x + window.scrollX) + 'px',
          'top:' + (rect.top + window.scrollY - 10) + 'px',
          'height:' + (rect.height + 20) + 'px'
        ].join(';');
        document.body.appendChild(mark);
      });
    });

    var panel = document.createElement('div');
    panel.style.cssText = [
      'position:fixed',
      'z-index:2147483647',
      'left:8px',
      'bottom:8px',
      'max-width:calc(100vw - 16px)',
      'padding:8px 10px',
      'background:#111',
      'color:#7CFF7C',
      'font:11px/1.45 ui-monospace,SFMono-Regular,Menlo,monospace',
      'white-space:pre-wrap',
      'border-radius:6px'
    ].join(';');
    panel.textContent = lines.join('\n');
    document.body.appendChild(panel);
  }

  function initInstance(root) {
    if (root.dataset.rytmSubboxInit === 'true') return;
    root.dataset.rytmSubboxInit = 'true';

    initOptions(root);
    initGallery(root);
    initAccordion(root);
    initCart(root);

    window.rytmSubboxDiagnose = function () { diagnose(root); };
    if (root.dataset.debug === 'true') diagnose(root);
    if (window.location.search.indexOf('subboxdebug') > -1) debugOverlay(root);
  }

  function initAll(context) {
    var scope = context || document;
    var instances = [];

    if (scope.matches && scope.matches('[data-rytm-subbox]')) {
      instances.push(scope);
    }
    if (scope.querySelectorAll) {
      Array.prototype.forEach.call(scope.querySelectorAll('[data-rytm-subbox]'), function (el) {
        instances.push(el);
      });
    }

    instances.forEach(initInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Re-init when a merchant adds/reorders this section in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();